import api from '..'

// used to delete a step from existing flow (put req doesn't delete steps)
export async function deleteStep(
  flowSlug: string,
  stepId: number,
): Promise<void> {
  await api.delete(`/flow/${flowSlug}/steps/${stepId}`)
}
